import { api } from '../api';
import { PriceTiersResponse } from './type';

export const WebshopPriceTiersApi = {
  getPriceTiers: async (): Promise<PriceTiersResponse> => {
    const { data } = await api.get<PriceTiersResponse>('/webshop/pricesheet');

    return data;
  },
};
